import React, { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { BrandProvider } from '../../context/BrandContext.jsx';
import NoBrandGate from '../NoBrandGate/NoBrandGate.jsx';
import BrandStyleProvider from '../BrandStyleProvider/BrandStyleProvider.jsx';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary.jsx';

const BrandChecker = lazy(() => import('../BrandChecker/BrandChecker.jsx'));
const NotFoundPage = lazy(() => import('../NotFoundPage/NotFoundPage.jsx'));

function PageFallback() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
      <p>Chargement…</p>
    </div>
  );
}

const App = () => (
  <BrandProvider>
    <NoBrandGate>
      <BrandStyleProvider>
        <Router>
          <ErrorBoundary>
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<BrandChecker />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </Router>
      </BrandStyleProvider>
    </NoBrandGate>
  </BrandProvider>
);

export default App;
